import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/models';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Select, message } from 'antd';
import SelectArrowIcon from '@/components/icons/SelectArrowIcon';
import qs from 'qs';
import cx from 'classnames';
import cs from './index.module.scss';
import NextStep from './components/nextStep';
import EmailList from '../components/emailList';
import '@/lib/gt';
import EyeShowIcon from '@/components/icons/EyeShowIcon';
import EyeHideIcon from '@/components/icons/EyeHideIcon';
import ClearIcon from '@/components/icons/ClearIcon';
import InvitePullDownIcon from '@/components/icons/InvitePullDownIcon';
import CheckBoxYes from '@/components/icons/CheckBoxYes';
import CheckBoxUn from '@/components/icons/CheckBoxUn';
import { isValidRegisterPassword } from '@/utils/registerPassword';
import backIcon from '@/assets/common/backIcon.png';
interface UserInfo {
  inviteCode?: number | string;
  telCountryCode?: number | string;
  username: number | string;
  password: number | string;
  confirmPassword: number | string;
}
const { Option } = Select;
const Register: React.FC = () => {
  const { t } = useTranslation();
  const { account, home, ui } = useStore();
  const { lang, countryList, fetchInit, setGeeResult, fetchisExit } = account;
  const { confList } = home;
  const { user_agreemen, privacy } = confList;
  const [loading, setLoading] = useState(false); // 第一个登录按钮
  const { search } = useLocation();

  const invite = ui.registerInviteCode;

  const inviteDisabled = useMemo(() => !!invite, [invite]);
  const [currentTab, setCurrentTab] = useState('email');
  const [type, setType] = useState('');
  const [userInfo, setUserInfo] = useState<UserInfo>({
    username: '',
    password: '',
    confirmPassword: '',
  });
  const captchaObj = useRef<any>(null);
  const inputRef = useRef(null);
  const [showPsw, setShowPsw] = useState(false); // 展示密码
  const [showPsw1, setShowPsw1] = useState(false); // 展示确认密码
  const [ifAgree, setIfAgree] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [form] = Form.useForm();
  const { push } = useHistory();
  const { username } = qs.parse(search?.slice(1));
  // 可用注册方式；仅一种时隐藏 tab
  const authTabs = [
    { key: 'email', label: t('common.email') },
    // { key: 'phone', label: t('common.sjh') }, // 临时关闭手机号注册
  ];
  const handleCurrentTab = (value: string) => {
    form.resetFields();
    setCurrentTab(value);
  };

  const handleSetIfAgree = (value: boolean) => {
    setIfAgree(value);
  };
  const isExit = geetest => {
    setGeeResult(geetest);
    const data = {
      userName: form.getFieldValue('username'),
      countryCode: form.getFieldValue('telCountryCode'),
      geetest: JSON.stringify(geetest),
    };
    fetchisExit(data)
      .then(res => {
        if (!res) return;
        const { exist } = res;
        if (!exist) {
          setIsNext(true);
        } else {
          message.error(t('signUp.exit'));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    invite && setShowInvite(true);
  }, [invite]);
  useEffect(() => {
    if (username) {
      !username?.includes('@') && setCurrentTab('phone');
    }
  }, [username]);

  useEffect(() => {
    const scriptId = 'dotlottie-player-script';
    if (document.getElementById(scriptId)) {
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.mjs';
    script.type = 'module';
    document.body.appendChild(script);
  }, []);

  // 初始化 userInfo
  useEffect(() => {
    if (ui.registerValue) {
      const isPhone = !ui.registerValue.includes('@');
      setCurrentTab(isPhone ? 'phone' : 'email');
      form.setFieldsValue({ 'username': ui.registerValue });
    }
  }, [ui.registerValue, form]);

  useEffect(() => {
    console.log('页面初始化', userInfo);
    // TODO: 本地调试 后期删除
    // form.setFieldsValue({
    //   username:'airwalkerman0@gmail.com',
    //   password: '!1Qaz2wsx',
    // });
    fetchInit().then(res => {
      if (res) {
        if (!res?.new_captcha) return;
        setType(res?.type);
        if (res?.type === 'neteasy') {
          initNECaptcha(
            {
              captchaId: res.gt,
              element: '#elementId',
              mode: 'popup',
              width: '320px',
              apiVersion: 2,
              lang: lang === 'en' ? 'en' : 'zh-CN',
              popupStyles: {
                position: 'fixed',
                top: '20%',
                // top: '100px',
                // right: '50px',
              },
              onVerify: (err, data) => {
                // 当验证失败时, 内部会自动 refresh 方法, 无需手动再调用一次
                if (err) return;
                // 以下为业务侧逻辑
                isExit(data);
                // captchaObj.current && captchaObj.current.refresh();
              },
              onClose: () => {
                captchaObj.current && captchaObj.current.refresh();
              },
            },
            instance => {
              captchaObj.current = instance;
              // setCaptchaObj(instance);
            },

            err => {
              // 初始化失败后触发该函数, err 对象描述当前错误信息
              console.log(err, 'err');
            },
          );

          // document.querySelector('#elementId').addEventListener('click', () => {
          //   captchaObj && captchaObj.verify();
          // });
        } else if (res?.type === 'aliyun') {
          initAlicom4(
            {
              captchaId: res.gt,
              product: 'bind',
              language: lang === 'zh' ? 'zho' : 'eng',
            },
            captcha => {
              captchaObj.current = captcha;
              // captcha为验证码实例
              // setCaptchaObj(captcha);
              captcha
                .onReady(() => {
                  // 验证码ready之后才能调用verify方法显示验证码
                })
                .onSuccess(() => {
                  const result = captcha.getValidate();

                  isExit({ ...result, graphicType: 'GEETEST' });
                })
                .onClose(() => {
                  setLoading(false);
                })
                .onError(() => {
                  // your code
                });
            },
          );
          return;
        } else {
          initGeetest4(
            {
              captchaId: res.gt,
              product: 'bind',
              language: lang === 'zh' ? 'zho' : 'eng',
            },
            captcha => {
              captchaObj.current = captcha;
              // captcha为验证码实例
              // setCaptchaObj(captcha);
              captcha
                .onReady(() => {
                  // 验证码ready之后才能调用verify方法显示验证码
                })
                .onSuccess(() => {
                  const result = captcha.getValidate();

                  isExit(result);
                  // if (!result) {
                  //   return alert('请完成验证');
                  // }
                })
                .onError(() => {
                  // your code
                })
                .onClose(() => {
                  setLoading(false);
                });
            },
          );
        }
      }
    });
  }, []);
  const prefixSelector = (
    <Form.Item name="telCountryCode" noStyle>
      <Select
        // style={{ width: 84 }}
        optionLabelProp="label"
        dropdownMatchSelectWidth={false}
        suffixIcon={<SelectArrowIcon />}
        className="selectNormal"
      >
        {countryList?.map((_: any) => (
          <Option value={_.code} key={_.id} label={`+${_.code}`} className="option">
            +{_.code} {lang === 'zh' ? _.zh : _.en}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  // 处理用户名输入变化
  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('handleUsernameChange', e.target.value);
    const value = e.target.value;
    setUserInfo({ ...userInfo, username: value });
  };
  const onFinish = (values: any) => {
    if (!isAgree) {
      message.error('请勾选同意条款');
      return;
    }
    console.log('Success:', values);
    setUserInfo(values);
    // if (!ifAgree) {
    //   message.error(t('signUp.tyfwtk'));
    //   return;
    // }
    if (type === 'neteasy') {
      captchaObj.current && captchaObj.current.verify();
    } else {
      captchaObj.current && captchaObj.current.showCaptcha();
    }
    setLoading(true);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', userInfo, form, errorInfo);
  };
  const back = () => {
    setIsNext(false);
  };
  // 是否可提交
  const isDisabled = useMemo(() => {
    if (!isAgree || !userInfo.username || !userInfo.password) {
      return true;
    }
    if (!isValidRegisterPassword(String(userInfo.password))) {
      return true;
    }
    if (currentTab === 'email') {
      return !/@+/.test(String(userInfo.username));
    }
    if (currentTab === 'phone') {
      return !/^[0-9]{7,}$/.test(String(userInfo.username));
    }
    return true;
  }, [isAgree, userInfo, currentTab]);

  const goServiceUrl = (type: keyof typeof baseUrls) => {
    const baseUrls = {
      yhxy: {
        zh: user_agreemen,
        en: user_agreemen,
      },
      yszc: {
        zh: privacy,
        en: privacy,
      },
    };

    // 获取对应的链接
    const url = lang === 'zh' ? baseUrls[type].zh : baseUrls[type].en;

    // 打开链接
    if (url) {
      window.open(url);
    } else {
      console.error('Invalid type provided to goServiceUrl.');
    }
  };

  const [showEmailList, setShowEmailList] = useState(false);

  return (
    <div
      className={cs.container}
      onClick={() => {
        ui.hideRegisterModal();
      }}
    >
      <div
        className={cs.contentBox}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className={cs.title}>
          {!isNext ? <span> {t('signUp.createaccout2')}</span> : <div className={cs.backIcon}>
            <img width={22} height={22} src={backIcon} alt="" onClick={back} />
          </div>}
          <div className={cs.toLogin}>
            <span className={cs.hasAccount}>{t('signUp.account')} </span>
            <span
              className="pointer"
              onClick={() => {
                // push('/login');
                ui.showLoginModal();
                ui.hideRegisterModal();
              }}
            >
              {t('signUp.loginnow')}
            </span>
          </div>
        </div>

        <div className={cs.contentBox2}>
          <div className={cs.left}>
            {/* <span> {t('signUp.title')}</span> */}
            <dotlottie-player
              src="/lottiejson/home_login_Lottie.json"
              background="transparent"
              speed="1"
              loop
              autoplay
              className={cs.loginLottie}
            />
          </div>
          {!isNext && (
            <div className={cs.content}>

              <div className={cx(cs.content_info)}>
                {authTabs.length > 1 && (
                  <div className={cs.tab}>
                    {authTabs.map(tab => (
                      <span
                        key={tab.key}
                        onClick={() => handleCurrentTab(tab.key)}
                        className={currentTab === tab.key ? cs.active : ''}
                      >
                        {tab.label}
                      </span>
                    ))}
                  </div>
                )}
                <div className={cs.form}>
                  <Form
                    form={form}
                    name="basic"
                    labelCol={{ flex: 1 }}
                    wrapperCol={{ flex: 1 }}
                    labelAlign="left"
                    initialValues={{ telCountryCode: '86', inviteCode: invite, username: username }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    layout="vertical"
                    requiredMark={false}
                  >
                    {currentTab === 'phone' ? (
                      <Form.Item
                        // label={t('common.sjhm')}
                        name="username"
                        rules={[{ required: true, message: t('common.srsjhm') }]}
                      >
                        {/* allowClear={{ clearIcon: chaCom }} */}

                        <Input
                          onChange={e => setUserInfo({ ...userInfo, username: e.target.value })}
                          className="bgIptAddonBefore"
                          addonBefore={prefixSelector}
                          placeholder={t('common.srsjhm')}
                          allowClear
                          value={userInfo.username}
                        />
                      </Form.Item>
                    ) : (
                      <Form.Item
                      // label={t('common.email')}

                      >
                        <Form.Item noStyle name="username" rules={[
                          { required: true, type: 'email', message: t('common.srzqdyxgs') },
                          // {
                          //   type: 'email',
                          //   message: t('common.srzqdyxgs'),
                          // },
                        ]}>
                          <Input
                            onChange={handleUsernameChange}
                            placeholder={t('common.emailPlace')}
                            className="iptDefault"
                            allowClear
                            onFocus={() => setShowEmailList(true)} // 🔹 聚焦时显示
                            onBlur={() => setTimeout(() => setShowEmailList(false), 200)} // 🔹 失焦时隐藏（延迟避免点击列表时消失）
                          />
                        </Form.Item>
                        {showEmailList && userInfo.username && (
                          <EmailList
                            curValue={String(userInfo.username)}
                            chooseEmail={selectedEmail => {
                              setUserInfo({ ...userInfo, username: selectedEmail });
                              form.setFieldsValue({ username: selectedEmail });
                              setShowEmailList(false);
                            }}
                          />
                        )}

                      </Form.Item>
                    )}
                    {currentTab === 'phone' && <div className={cs.line}></div>}
                    <Form.Item
                      // label={t('common.psd')}
                      name="password"
                      rules={[
                        // { required: true, message: t('common.enterpsd') },
                        // { min: 8, max: 20, message: t('common.psdrule') },
                        () => ({
                          validator(_: unknown, value: string) {
                            if (!isValidRegisterPassword(value)) {
                              return Promise.reject(new Error(t('common.psdregex')));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <Input
                        className="iptSuffix"
                        placeholder={t('common.enterpsd')}
                        ref={inputRef}
                        type={showPsw ? 'text' : 'password'}
                        onChange={e => setUserInfo({ ...userInfo, password: e.target.value })}
                        maxLength={32}
                        suffix={
                          showPsw ? (
                            <EyeShowIcon
                              onClick={() => {
                                setShowPsw(!showPsw);
                              }}
                            />
                          ) : (
                            <EyeHideIcon
                              onClick={() => {
                                setShowPsw(!showPsw);
                              }}
                            />
                          )
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name="confirmPassword"
                      dependencies={['password']}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject(new Error(t('common.againpsd')));
                            }
                            if (getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(t('common.psddif')));
                          },
                        }),
                      ]}
                    >
                      <Input
                        className="iptSuffix"
                        placeholder={t('common.againpsd')}
                        ref={inputRef}
                        type={showPsw1 ? 'text' : 'password'}
                        maxLength={32}
                        onChange={e => setUserInfo({ ...userInfo, confirmPassword: e.target.value })}
                        suffix={
                          showPsw1 ? (
                            <EyeShowIcon
                              onClick={() => {
                                setShowPsw1(!showPsw1);
                              }}
                            />
                          ) : (
                            <EyeHideIcon
                              onClick={() => {
                                setShowPsw1(!showPsw1);
                              }}
                            />
                          )
                        }
                      />
                    </Form.Item>
                    <div className={cs.invite}>
                      {t('signUp.invitecode')}
                      <InvitePullDownIcon
                        className={cx(showInvite ? cs.rotate : '')}
                        onClick={() => {
                          setShowInvite(!showInvite);
                        }}
                      />
                    </div>

                    {showInvite && (
                      <Form.Item
                        // label={t('signUp.invitecode')}
                        name="inviteCode"
                        rules={[{ required: false, message: t('signUp.invitecodePlace') }]}
                      >
                        <Input
                          placeholder={t('signUp.invitecodePlace')}
                          disabled={inviteDisabled}
                          className="iptDefault"
                        />
                      </Form.Item>
                    )}
                    <div className={cs.tip}>
                      <span
                        className={cs.checkbox}
                        onClick={() => {
                          setIsAgree(!isAgree);
                        }}
                      >
                        {isAgree ? <CheckBoxYes /> : <CheckBoxUn />}
                      </span>
                      <span className={cs.agreeText}> {t('signUp.areen1')} </span>
                      <span
                        className={cx('pointer', cs.link)}
                        onClick={() => {
                          goServiceUrl('yhxy');
                        }}
                      >
                        {t('signUp.yhxy')}
                      </span>
                      <span className={cs.agreeText}>{t('signUp.and')}</span>
                      <span
                        className={cx('pointer', cs.link)}
                        onClick={() => {
                          goServiceUrl('yszc');
                        }}
                      >
                        {t('signUp.yszc')}
                      </span>
                    </div>
                    <div className={cs.btn}>
                      <Button
                        loading={loading}
                        type="primary"
                        htmlType="submit"
                        className={cx('btnPrimary', cs.registerBtn, isDisabled ? cs.disabledBtn : '')}
                        style={{ height: '40px', width: '100%' }}
                      >
                        {t('btn.signUp')}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          )}
          {isNext && <NextStep currentTab={currentTab} back={back} userInfo={userInfo} />}
        </div>



      </div>
    </div>
  );
};

export default observer(Register);
